import { render, staticRenderFns } from "./ImportCommon.vue?vue&type=template&id=1f9da8b0&scoped=true"
import script from "./ImportCommon.vue?vue&type=script&lang=js"
export * from "./ImportCommon.vue?vue&type=script&lang=js"
import style0 from "./ImportCommon.vue?vue&type=style&index=0&id=1f9da8b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f9da8b0",
  null
  
)

export default component.exports